import React from 'react';
import searchIcon from '../../assets/images/searchIcon.svg';
interface SearchBarProps {
    searchTerm: string;
    setSearchTerm: (term: string) => void;
    placeHolder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
    searchTerm,
    setSearchTerm,
    placeHolder,
}) => {
    return (
        <div className="w-[50%] h-[2.8rem] outline-none px-2 border-[0.1rem] border-gray-300 rounded-xl ml-24 flex justify-center">
            <img src={searchIcon} alt="Search Icon" className="w-6 h-auto" />
            <input
                type="text"
                className="pl-2 w-[20rem] h-full outline-none border-none"
                placeholder={placeHolder ? placeHolder : 'Search'}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
        </div>
    );
};

export default SearchBar;
